module.exports = function (Konva) {
    'use strict';
    function PlayheadLayer(options) {
        this._player = options.player;
        this._view = options.view;
        this._playheadPixel = 0;
        this._playheadLineAnimation = null;
        this._playheadVisible = false;
        this._playheadColor = options.playheadColor;
        this._playheadTextColor = options.playheadTextColor;
        this._playheadFontFamily = options.playheadFontFamily || 'sans-serif';
        this._playheadFontSize = options.playheadFontSize || 11;
        this._playheadFontStyle = options.playheadFontStyle || 'normal';
        this._playheadLayer = new Konva.Layer();
        this._createPlayhead(this._playheadColor);
        if (options.showPlayheadTime) {
            this._createPlayheadText(this._playheadTextColor);
        }
        this.fitToView();
        this.zoomLevelChanged();
    }
    PlayheadLayer.prototype.addToStage = function (stage) {
        stage.add(this._playheadLayer);
    };
    PlayheadLayer.prototype.zoomLevelChanged = function () {
        var pixelsPerSecond = this._view.timeToPixels(1);
        var time;
        this._useAnimation = pixelsPerSecond >= 5;
        if (this._useAnimation) {
            if (this._player.isPlaying() && !this._playheadLineAnimation) {
                this._start();
            }
        } else {
            if (this._playheadLineAnimation) {
                time = this._player.getCurrentTime();
                this.stop(time);
            }
        }
    };
    PlayheadLayer.prototype.fitToView = function () {
        var height = this._view.getHeight();
        this._playheadLine.points([
            0.5,
            0,
            0.5,
            height
        ]);
        if (this._playheadText) {
            this._playheadText.y(12);
        }
    };
    PlayheadLayer.prototype._createPlayhead = function (color) {
        this._playheadLine = new Konva.Line({
            stroke: color,
            strokeWidth: 1
        });
        this._playheadGroup = new Konva.Group({
            x: 0,
            y: 0
        });
        this._playheadGroup.add(this._playheadLine);
        this._playheadLayer.add(this._playheadGroup);
    };
    PlayheadLayer.prototype._createPlayheadText = function (color) {
        var time = this._player.getCurrentTime();
        var text = this._view.formatTime(time);
        this._playheadText = new Konva.Text({
            x: 2,
            y: 0,
            text: text,
            fontSize: this._playheadFontSize,
            fontFamily: this._playheadFontFamily,
            fontStyle: this._playheadFontStyle,
            fill: color,
            align: 'right'
        });
        this._playheadGroup.add(this._playheadText);
    };
    PlayheadLayer.prototype.updatePlayheadTime = function (time) {
        this._syncPlayhead(time);
        if (this._player.isPlaying()) {
            this._start();
        }
    };
    PlayheadLayer.prototype._syncPlayhead = function (time) {
        var pixelIndex = this._view.timeToPixels(time);
        var frameOffset = this._view.getFrameOffset();
        var width = this._view.getWidth();
        var isVisible = pixelIndex >= frameOffset && pixelIndex < frameOffset + width;
        this._playheadPixel = pixelIndex;
        if (isVisible) {
            var playheadX = this._playheadPixel - frameOffset;
            if (!this._playheadVisible) {
                this._playheadVisible = true;
                this._playheadGroup.show();
            }
            this._playheadGroup.setX(playheadX);
            if (this._playheadText) {
                var text = this._view.formatTime(time);
                var playheadTextWidth = this._playheadText.getTextWidth();
                this._playheadText.setText(text);
                if (playheadTextWidth + playheadX > width - 2) {
                    this._playheadText.setX(-playheadTextWidth - 2);
                } else if (playheadTextWidth + playheadX < width) {
                    this._playheadText.setX(2);
                }
            }
            this._playheadLayer.draw();
        } else {
            if (this._playheadVisible) {
                this._playheadVisible = false;
                this._playheadGroup.hide();
                this._playheadLayer.draw();
            }
        }
    };
    PlayheadLayer.prototype._start = function () {
        var self = this;
        if (self._playheadLineAnimation) {
            self._playheadLineAnimation.stop();
            self._playheadLineAnimation = null;
        }
        if (!self._useAnimation) {
            return;
        }
        var lastPlayheadPosition = null;
        self._playheadLineAnimation = new Konva.Animation(function () {
            var time = self._player.getCurrentTime();
            var playheadPosition = self._view.timeToPixels(time);
            if (playheadPosition !== lastPlayheadPosition) {
                self._syncPlayhead(time);
                lastPlayheadPosition = playheadPosition;
            }
        }, self._playheadLayer);
        self._playheadLineAnimation.start();
    };
    PlayheadLayer.prototype.stop = function (time) {
        if (this._playheadLineAnimation) {
            this._playheadLineAnimation.stop();
            this._playheadLineAnimation = null;
        }
        this._syncPlayhead(time);
    };
    PlayheadLayer.prototype.getPlayheadOffset = function () {
        return this._playheadPixel - this._view.getFrameOffset();
    };
    PlayheadLayer.prototype.getPlayheadPixel = function () {
        return this._playheadPixel;
    };
    PlayheadLayer.prototype.showPlayheadTime = function (show) {
        var updated = false;
        if (show) {
            if (!this._playheadText) {
                this._createPlayheadText(this._playheadTextColor);
                this.fitToView();
                updated = true;
            }
        } else {
            if (this._playheadText) {
                this._playheadText.remove();
                this._playheadText.destroy();
                this._playheadText = null;
                updated = true;
            }
        }
        if (updated) {
            this._playheadLayer.draw();
        }
    };
    PlayheadLayer.prototype.updatePlayheadText = function () {
        if (this._playheadText) {
            var time = this._player.getCurrentTime();
            var text = this._view.formatTime(time);
            this._playheadText.setText(text);
        }
        this._playheadLayer.draw();
    };
    PlayheadLayer.prototype.destroy = function () {
        if (this._playheadLineAnimation) {
            this._playheadLineAnimation.stop();
            this._playheadLineAnimation = null;
        }
    };
    return PlayheadLayer;
}(require('konva'));